import { io } from "socket.io-client";
import getUrl from "./getApiUrl";

const socket = io(getUrl(), {
  autoConnect: false,
  transports: ["websocket", "polling"],
  withCredentials: true,
});
export default socket;
